import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as AltIcon } from '../../../assets/img/alt.svg';
import { useTranslation } from 'react-i18next';
import useAccessType from '../../../hooks/useAccessType.js';
import { useState } from 'react';
import AccessModal from '../../../components/Modal/AccessModal.jsx';

function ImageScreen() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const {getAccessType} = useAccessType(true);
    const [modalType, setModalType] = useState(null);
    const [modalShow, setModalShow] = useState(false);

    const handleModuleClick = (path) => {
        const accessType = getAccessType();
        if (!accessType) {
            navigate(path);
        } else {
            setModalType(accessType);
            setModalShow(true);
        }
    };

    const modules = [
        { id: 1, label: 'image.alt.altImage', path: '/image/alt', icon: AltIcon },
    ];

    return (
        <Container className="py-5">
            <Row className="mb-5">
                <Col xs={12} className="text-center">
                    <h2 className="title">{t('app.chooseAModule')}</h2>
                </Col>
            </Row>

            <Row className="mb-4 g-4 justify-content-center">
                {modules.map((module) => {
                    const IconComponent = module.icon;
                    return (
                        <Col key={module.id} xs={12} md={6} className="card-custom-container">
                            <div
                                className="card-custom-content d-flex align-items-center justify-content-center flex-column text-center"
                                onClick={() => handleModuleClick(module.path)}
                                role="button"
                                style={{ aspectRatio: '1 / 1', overflow: 'hidden' }}
                            >
                                <IconComponent className="mb-3 card-svg" />
                                <h3 className="card-title text-capitalize">
                                    {t(module.label)}
                                </h3>
                            </div>
                        </Col>
                    );
                })}
            </Row>

            <AccessModal
                show={modalShow}
                setShow={setModalShow}
                modalType={modalType}
            />
        </Container>
    );
}

export default ImageScreen;